import { CategoryBundlesApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useCategoryBundlesAPI(): CategoryBundlesApi {
  return new CategoryBundlesApi(apiConfig);
}
